import React, { useMemo } from "react";
import { createAuthApi } from "../api/authApi.js";
import { AuthContext } from "./AuthContext.js";
export function AuthProvider({ config, children }) {
    const api = useMemo(()=>createAuthApi(config.graphqlUrl), [
        config.graphqlUrl
    ]);
    const value = useMemo(()=>({
            config,
            api
        }), [
        config,
        api
    ]);
    return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
        value: value
    }, children);
}

//# sourceMappingURL=AuthProvider.js.map